



























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import FeedbackInvoiceModal from '../modals/FeedbackInvoiceModal.vue';
import moment from 'moment-timezone';
import VueMonthlyPicker from 'vue-monthly-picker';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'feedback-invoices',
    data: function () {
        return {
            invoiceFeedbacksPage_: 1,
        };
    },
    components: {
        FeedbackInvoiceModal,
        VueMonthlyPicker,
        Spinner,
    },
    filters: {
        date(val: any) {
            // return moment(val).format('YYYY/MM/DD');
            return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');

        },
        dateFil(val) {
            return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('feedbackInvoices', [
            'allFeedbackInvoices',
            'allFeedbackInvoicesLoading',
            'invoiceFeedbacksPerPage',
            'invoiceFeedbacksPage',
            'invoiceFeedbacksTotal',
        ]),
        ...mapState('feedbackInvoices', {}),
    },
})
export default class FeedbackInvoices extends Vue {
    public allFeedbackInvoices!: any;
    public allFeedbackInvoicesLoading!: any;
    public invoiceFeedbacksPerPage!: any;
    public invoiceFeedbacksPage!: any;
    public invoiceFeedbacksPage_!: any;
    public invoiceFeedbacksTotal!: any;
    public invoice_feedback_word_search: any = '';
    public dateRange: any = {
        startDate: null,
        endDate: null,
    };

    singleDatePicker: any = 'range';
    allFeedbackInvoicesHeaders = [
        { thClass: 'th', key: 'prodelec_order', label: 'Venta' },
        { thClass: 'th', key: 'date_created', label: 'Fecha' },
        { thClass: 'th', key: 'status', label: 'Estatus' },
        { thClass: 'th', key: 'edit', label: '' },
    ];
    public status_filter: any = null;
    status_filter_options: any = [
        { value: null, text: 'Todos', disabled: true },
        { value: 'new', text: 'Nuevas' },
        { value: 'pending', text: 'Pendientes' },
        { value: 'closed', text: 'Concluidas' },
        { value: 'cancelled', text: 'Canceladas' },
    ];

    setUrlPage(page: any) {
        this.$router.push({
            path: 'feedback-invoices',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.invoiceFeedbacksPage_ = page;
    }

    setUrlSearch(search: string) {
        search = search.trim();
        this.$router.push({
            path: 'feedback-invoices',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    onFilterDateRange() {
        let start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
        let end_date: any = moment(this.dateRange.endDate).add(1, 'd');
        end_date = moment(end_date).format('YYYY/MM/DD') + '';
        // console.log(start_date, '--', end_date);
        this.$router.push({
            path: 'feedback-invoices',
            query: {
                ...this.$route.query,
                start_date: start_date,
                end_date: end_date,
            },
        });
    }

    clearFilters() {
        this.invoice_feedback_word_search = '';
        this.status_filter = null;
        this.$router.push({
            path: 'feedback-invoices',
            query: {},
        });
        this.invoiceFeedbacksPage_ = 1;
        this.dateRange = {
            startDate: null,
            endDate: null,
        };
    }

    onOpenFeedbackInvoiceModal(id: string | null = null) {
        this.$store.dispatch('feedbackInvoices/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('feedback-invoice-modal');
        }, 400);
    }

    onFilterStatus(status: any) {
        this.$router.push({
            path: 'feedback-invoices',
            query: {
                ...this.$route.query,
                status_filter: status,
            },
        });
    }

    @Watch('$route')
    getAllInvoices() {
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const status_filter = this.$route.query.status_filter || null;
        const start_date = this.$route.query.start_date || null;
        const end_date = this.$route.query.end_date || null;

        this.$store.dispatch('feedbackInvoices/getAll', {
            page,
            search,
            status_filter,
            start_date,
            end_date,
        });
    }

    mounted() {
        this.getAllInvoices();
        this.invoiceFeedbacksPage_ = 1;
    }
}
